import { buildApiEndpoint, withQueryString } from 'helpers/apiHelpers';
import { rest } from 'catering/api';
import { sortBy } from 'lodash';

export const LOCATIONS_BASE_ENDPOINT = buildApiEndpoint(
  '/api/catering/locations'
);

export const LOCATIONS_GET_ENDPOINT = `${LOCATIONS_BASE_ENDPOINT}/`;

export const getCateringLocationFulfillmentHoursEndpoint = (
  locationSlug,
  queryParams
) => {
  const endpoint = `${LOCATIONS_BASE_ENDPOINT}/${locationSlug}/fulfillment-hours/`;
  return withQueryString(endpoint, queryParams);
};

export const getCateringLocationFirstAvailableFulfillmentHoursEndpoint = locationSlug => {
  return `${LOCATIONS_BASE_ENDPOINT}/${locationSlug}/first-available-fulfillment-hours/`;
};

export const getCateringLocationDeliveryZoneFromAddressEndpoint = (
  locationSlug,
  queryParams = {}
) => {
  const endpoint = `${LOCATIONS_BASE_ENDPOINT}/${locationSlug}/delivery-zone/`;
  return withQueryString(endpoint, queryParams);
};

export const getCateringLocationMenuAvailabilityEndpoint = locationSlug => {
  return `${LOCATIONS_BASE_ENDPOINT}/${locationSlug}/menus/`;
};

export const getCateringLocationsWithUserAddressEndpoint = (
  userAddress = {}
) => {
  return withQueryString(LOCATIONS_BASE_ENDPOINT, userAddress);
};

export const getCateringLocationInventoryEndpoint = (
  locationSlug,
  queryParams
) => {
  const endpoint = `${LOCATIONS_BASE_ENDPOINT}/${locationSlug}/inventory/`;
  return withQueryString(endpoint, queryParams);
};

export async function getCateringLocations() {
  return sortBy(await rest.get(LOCATIONS_GET_ENDPOINT), 'location.order');
}

export async function getCateringLocationFulfillmentHours({
  locationSlug,
  queryParams
}) {
  return rest.get(
    getCateringLocationFulfillmentHoursEndpoint(locationSlug, queryParams)
  );
}

export async function getCateringLocationFirstAvailableFulfillmentHours(
  locationSlug
) {
  return rest.get(
    getCateringLocationFirstAvailableFulfillmentHoursEndpoint(locationSlug)
  );
}

export async function getCateringLocationDeliveryZoneFromAddress(
  locationSlug,
  queryParams
) {
  return rest.get(
    getCateringLocationDeliveryZoneFromAddressEndpoint(
      locationSlug,
      queryParams
    )
  );
}

export async function getCateringLocationMenuAvailability(locationSlug) {
  return rest.get(getCateringLocationMenuAvailabilityEndpoint(locationSlug));
}

export async function getCateringLocationsWithUserAddress(userAddress) {
  return rest.get(getCateringLocationsWithUserAddressEndpoint(userAddress));
}

export const getCateringLocationInventory = (locationSlug, queryParams) =>
  rest.get(getCateringLocationInventoryEndpoint(locationSlug, queryParams));
